export default "__VITE_ASSET__81661180__"